<!-- *FORMULARIO CREAR EDITAR -->
<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplate]="innTemplate"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplate>
    <form [formGroup]="formulario" class="form-group" novalidate>
      <div class="container">
        <div class="row col-12">
          <div class="form-group col-md-4">
            <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('ordBalanza')"
                            [id]="'ordBalanza'" [label]="'Orden de balanza*'"
                            [placeholder]="'Ingrese orden de balanza'" [type]="'number'"
                            formControlName="ordBalanza">
            </app-lfsa-input>
          </div>
          <div class="col-md-8">
            <br>
            <button (click)="imprimirTicket()" [disabled]="formulario.invalid" class="btn btn-success btn-block">
              <i aria-hidden="true" class="fa fa-floppy-o"></i>
              Generar
            </button>
          </div>

          <div class="row col-12">

          </div>
        </div>

        <div class="row">
          <div class="col-md-12 ">

          </div>
        </div>
      </div>
    </form>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->

  <!-- GRILLA -->
</div>
